import React, { useCallback, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { loadBureauReports } from 'src/store/actions/bureauReportActions';
import { selectBureauReportQueryOptions } from 'src/store/selectors/bureauReportSelector';
import { ReportType } from 'src/utils/constants/buro-reports';
import BureauReportList from './BureauReportList';

const TAB_TO_REPORT_TYPE = [ReportType.MONTHLY, ReportType.PARTIAL];

const BureauReportListTabs = () => {
  const [tabIndex, setTabIndex] = React.useState(0);
  const queryOpts = useSelector(selectBureauReportQueryOptions);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(
      loadBureauReports({
        ...queryOpts,
        reportType: TAB_TO_REPORT_TYPE[tabIndex]
      })
    );
  }, []);

  const handleChange = useCallback(
    (_, newValue) => {
      setTabIndex(newValue);
      dispatch(
        loadBureauReports({
          ...queryOpts,
          page: 0,
          reportType: TAB_TO_REPORT_TYPE[newValue]
        })
      );
    },
    [setTabIndex, dispatch, queryOpts]
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        variant="outlined"
        position="static"
        sx={{
          border: 'none',
          borderBottom: '1px solid rgba(43,45,66,0.1)',
          background: 'transparent',
          flexDirection: 'row'
        }}
      >
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          value={tabIndex}
          onChange={handleChange}
        >
          <Tab label={t('BUREAU_REPORTS.MONTHLY')} />
          <Tab label={t('BUREAU_REPORTS.PARTIAL')} />
        </Tabs>
      </AppBar>
      <BureauReportList />
    </Box>
  );
};

export default BureauReportListTabs;
